export default __webpack_public_path__ + "static/media/seta.642649c7.svg";